<template>
  <v-layout row wrap fill-height align-content-space-between class="mb-3">
    <v-flex grow text-xs-center text-sm-center text-md-left>
      <h1 class="font-weight-light">
        <v-icon large class="mr-2 primary--text">
          <slot name="icon"></slot>
        </v-icon>

        <span class="primary--text">
          <slot name="title"></slot>
        </span>
      </h1>
    </v-flex>

    <v-flex shrink class="hidden-sm-and-down" text-sm-center text-md-right  v-if="$isDesktopDevice">
      <MenuDesktop>
        <template #menu>
          <slot name="menu"></slot>
        </template>
      </MenuDesktop>
    </v-flex>
    <v-flex grow text-xs-right v-if="$isMobileDevice">
      <MenuMobile>
        <template #menu>
          <slot name="menu"></slot>
        </template>
      </MenuMobile>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    skin: {
      type: Object,
      required: true
    }
  },
  components: {
    MenuDesktop: () => import("./Menu.desktop"),
    MenuMobile: () => import ("./Menu.mobile")
  }
}
</script>